import { IPlan, IPlanDelete, IPlanDetail, IPlanForm, IPlans } from '@/types/plan';
import { BaseService, endpoints, http } from './base';

export class PlanService extends BaseService<IPlan> {
  constructor() {
    super(endpoints.plans.default);
  }

  public async getDetail(id: string): Promise<IPlanDetail> {
    const { data: res } = await http.get(this.url + '/' + id);
    return res;
  }

  public async getAll(params?: any): Promise<IPlans> {
    const { data: res } = await http.get(this.url, { params });
    return res;
  }

  public async storeData(body: Partial<IPlanForm>): Promise<IPlan> {
    const formData = new FormData();

    formData.append('name', body.name || '');
    formData.append('price', (body.price || 0).toString());
    formData.append('description', body.description || '');

    if (body.htmlFile) {
      formData.append('files', body.htmlFile);
    }
    if (body.cssFile) {
      formData.append('files', body.cssFile);
    }
    if (body.jsFile) {
      formData.append('files', body.jsFile);
    }
    if (body.imageZipFile) {
      formData.append('files', body.imageZipFile);
    }

    const { data } = await http.post(this.url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  }

  public async updateData(id: string, body: Partial<IPlanForm>): Promise<IPlan> {
    const formData = new FormData();

    formData.append('name', body.name || '');
    formData.append('price', (body.price || 0).toString());
    formData.append('description', body.description || '');

    if (body.htmlFile) {
      formData.append('files', body.htmlFile);
    }
    if (body.cssFile) {
      formData.append('files', body.cssFile);
    }
    if (body.jsFile) {
      formData.append('files', body.jsFile);
    }
    if (body.imageZipFile) {
      formData.append('files', body.imageZipFile);
    }

    const { data } = await http.patch(this.url + '/' + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  }

  public async deleteData(id: string): Promise<IPlanDelete> {
    const { data: res } = await http.delete(this.url + '/' + id);
    return res;
  }
}
